import React, { useState } from 'react';
import { LuChevronDown, LuChevronRight } from 'react-icons/lu';

import { AssignedWithdrawal } from '@ndvr/portfolio-api';

import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { formatDate, isFutureDate } from 'utils/date-formatter';
import { formatCurrency } from 'utils/number-formatter';

interface RmdPlannedWithdrawalsProps {
    withdrawals: AssignedWithdrawal[];
    defaultOpen?: boolean;
}

export const RmdPlannedWithdrawals: React.FC<RmdPlannedWithdrawalsProps> = ({ withdrawals, defaultOpen = false }) => {
    const [open, setOpen] = useState(defaultOpen);

    const future = withdrawals.filter((w) => isFutureDate(w.withdrawalDate));
    const total = future.reduce((s, w) => s + parseFloat(w.finalAmount), 0);

    return (
        <div className="rounded-md border bg-white">
            <button
                className="flex w-full items-center justify-between px-4 py-3 text-sm font-semibold text-gray-700 hover:bg-gray-50"
                onClick={(e) => {
                    e.stopPropagation();
                    setOpen((v) => !v);
                }}
            >
                <span className="flex items-center gap-2">
                    {open ? <LuChevronDown className="h-4 w-4" /> : <LuChevronRight className="h-4 w-4" />}
                    Planned Withdrawals
                </span>
                <span className="text-xs font-normal text-gray-500">
                    {future.length} planned, {formatCurrency(total)}
                </span>
            </button>
            {open && (
                <div className="max-h-60 overflow-y-auto">
                    <Table>
                        <TableHeader className="sticky top-0 z-10">
                            <TableRow className="bg-gray-50">
                                <TableHead className="text-xs font-medium text-gray-500">Date</TableHead>
                                <TableHead className="text-right text-xs font-medium text-gray-500">Amount</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {future.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={2} className="py-4 text-center text-sm text-gray-400">
                                        No planned withdrawals
                                    </TableCell>
                                </TableRow>
                            ) : (
                                future.map((w, i) => (
                                    <TableRow key={i}>
                                        <TableCell className="text-sm">{formatDate(w.withdrawalDate)}</TableCell>
                                        <TableCell className="text-right text-sm">
                                            {formatCurrency(parseFloat(w.finalAmount))}
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </div>
            )}
        </div>
    );
};
